import { UserRole } from "@/types/user";

export const mapRoleToLabel = (role: UserRole) => {
  switch (role) {
    case "ORG_ADMIN":
      return "Responsable";
    case "ORG_USER":
      return "Usuario";
    case "STAFF":
      return "Staff";
    default:
      return "";
  }
};
